import { normalize, schema } from 'normalizr';

const savedSearch = new schema.Entity('searches', {}, { idAttribute: 'SearchId' });

export default savedSearch;
